import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "flex-center items-stretch"
};
const _hoisted_2 = {
  class: "flex-1 flex-center flex-col p-1 bg-slate-100 rounded mr-1 last:mr-0"
};
const _hoisted_3 = {
  key: 0,
  class: "flex w-full grow"
};
const _hoisted_4 = {
  class: "flex-1 flex-center"
};
const _hoisted_5 = {
  class: "flex-1 flex-center"
};
const _hoisted_6 = {
  class: "flex-1 flex-center"
};
const _hoisted_7 = {
  key: 1,
  class: "opacity-50 font-bold flex-center"
};
const _hoisted_8 = {
  key: 2,
  class: "flex-center text-xs w-full"
};
import Icon from "@/modules/vue/components/Icon.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'MatchLanes',
  props: {
    ballPosition: null,
    possession: null,
    lanes: null
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.times(5), i => {
        return _openBlock(), _createElementBlock("div", _hoisted_2, [__props.ballPosition === i ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [__props.possession === 'away' ? (_openBlock(), _createBlock(Icon, {
          key: 0,
          icon: _ctx.IconEnum.ArrowLeft32Filled,
          size: ".75rem",
          class: "text-red-700"
        }, null, 8, ["icon"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, [_createVNode(Icon, {
          icon: _ctx.IconEnum.Futbol,
          size: "1rem"
        }, null, 8, ["icon"])]), _createElementVNode("div", _hoisted_6, [__props.possession === 'home' ? (_openBlock(), _createBlock(Icon, {
          key: 0,
          icon: _ctx.IconEnum.ArrowRight32Filled,
          size: ".75rem",
          class: "text-green-700"
        }, null, 8, ["icon"])) : _createCommentVNode("", true)])])) : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(i), 1)), __props.lanes ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", {
          class: _normalizeClass(["flex-1 mr-0.5", {
            'text-green-700': __props.lanes.home[i].effectiveSkill > __props.lanes.away[__props.lanes.away.length - 1 - i].effectiveSkill,
            'text-red-700': __props.lanes.home[i].effectiveSkill < __props.lanes.away[__props.lanes.away.length - 1 - i].effectiveSkill
          }])
        }, _toDisplayString(__props.lanes.home[i].effectiveSkill), 3), _createElementVNode("div", {
          class: _normalizeClass(["flex-1 text-right ml-0.5", {
            'text-green-700': __props.lanes.away[__props.lanes.away.length - 1 - i].effectiveSkill > __props.lanes.home[i].effectiveSkill,
            'text-red-700': __props.lanes.away[__props.lanes.away.length - 1 - i].effectiveSkill < __props.lanes.home[i].effectiveSkill
          }])
        }, _toDisplayString(__props.lanes.away[__props.lanes.away.length - 1 - i].effectiveSkill), 3)])) : _createCommentVNode("", true)]);
      }), 256))]);
    };
  }
});